module.exports = __webpack_public_path__ + "static/img/brees-2002-slide-4.cb73c8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2002-slide-4.jpg
// module id = AZHh
// module chunks = 1